import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import VolunteerLayout from "layouts/volunteer";
import MemberLayout from "layouts/member";
import "assets/css/Plugins.css";
import { useState, useEffect } from "react";
import { ThemeProvider } from "hooks/useTheme";
import { AuthProvider } from "hooks/useAuth";
import NotFound from "views/errors/404";
import { ErrorBoundary } from "views/errors/error-boundary";
import { Toaster } from "react-hot-toast";
import AdminPage from "pages/adminPage";

const App = () => { 

  // Create a new context
  const [themeApp, setThemeApp] = useState({
    
    "--background-100": "#FFFFFF",
    "--background-900": "#070f2e",
    "--shadow-100": "rgba(112, 144, 176, 0.2)",
    "--shadow-500": "rgba(11, 14, 17, 0.2)",
    "--color-50": "#E8F8F1",
    "--color-100": "#E8F8F1",
    "--color-200": "#E8F8F1",
    "--color-300": "#E8F8F1",
    "--color-400": "#D9EBE3",
    "--color-500": "#91B9A8",
    "--color-600": "#6DA38C",
    "--color-700": "#3F6A58",
    "--color-800": "#016B44",
    "--color-900": "#016B44",
    "--color-arrow-green": "#45AF82",
  });

  // When the theme state changes, this effect will update the CSS variables in the document's root element
  useEffect(() => {
    let color;
    for (color in themeApp) {
      document.documentElement.style.setProperty(color, themeApp[color as keyof typeof themeApp]);
    }

 
    //eslint-disable-next-line
  }, [themeApp]);
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
        <Toaster position="top-center" reverseOrder={false} />
          <Routes>
            <Route path="volunteer/*" element={<VolunteerLayout />} />
            <Route path="member/*" element={<MemberLayout />} />
            <Route path="auth/*" element={<AuthLayout />} />
            <Route
              path="admin/*"
              element={
                <AdminLayout
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
            <Route path="/" element={<Navigate to="/admin" replace />} />

            <Route path="*" element={<div className="bg-white dark:bg-background-900 dark:text-white flex flex-row min-h-screen"><NotFound /></div>} />
             <Route path="only-us" element={<AdminPage />} />
          </Routes>
        </AuthProvider>
                  
      </ThemeProvider>
    </ErrorBoundary>
  );
};


export default App;
